import React from 'react';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import {
  DocumentTextIcon,
  DocumentChartBarIcon,
  BanknotesIcon,
  ArrowTrendingUpIcon,
} from '@heroicons/react/24/outline';

const Dashboard = () => {
  usePageTitle('Dashboard');
  const navigate = useNavigate();

  const dashboards = [
    {
      title: 'AP Invoices',
      description: 'Accounts Payable invoices dashboard',
      icon: DocumentTextIcon,
      color: 'blue',
      path: '/dashboards/ap-invoices',
    },
    {
      title: 'AR Invoices',
      description: 'Accounts Receivable invoices dashboard',
      icon: DocumentChartBarIcon,
      color: 'green',
      path: '/dashboards/ar-invoices',
    },
    {
      title: 'P&L Statement',
      description: 'Profit & Loss statement dashboard',
      icon: ArrowTrendingUpIcon,
      color: 'purple',
      path: '/dashboards/pnl-statement',
    },
    {
      title: 'Cash Flow Statement',
      description: 'Cash flow analysis dashboard',
      icon: BanknotesIcon,
      color: 'yellow',
      path: '/dashboards/cash-flow',
    },
  ];

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <p className="page-subtitle">Scalepunk holding ERP</p>
        </div>
      </div>

      <div className="stats-grid">
        {dashboards.map((dashboard) => {
          const Icon = dashboard.icon;
          return (
            <div
              key={dashboard.path}
              className="stat-card"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(dashboard.path)}
            >
              <div className={`stat-icon ${dashboard.color}`}>
                <Icon style={{ width: 24, height: 24 }} />
              </div>
              <div className="stat-content">
                <div className="stat-value" style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>
                  {dashboard.title}
                </div>
                <div className="stat-subtext">{dashboard.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Dashboard;
